<template>

	<div class="learning_cont">
		<section class="learning_test">

			<!-- 테스트 시작 페이지 -->
			<ans-tst-start v-if="!isStart" :tst-count="qstTstList.length" @tstStart="tstStart"></ans-tst-start>


			<!-- 테스트 본 컨텐츠 -->
			<section class="learning_test" v-show="isStart && !isFinal">
				<div class="test_ing">
					<div class="q_wrap">
						<strong>{{ qstTstList[index].tstTitle }}</strong>
						<p v-if="qstTstList[index].isTxt">{{ qstTstList[index].tstDesc }}</p>
						<div class="img_wrap">
							<div class="img_question" v-if="qstTstList[index].isImg"><img :src="qstTstList[index].tstImgSrc"></div>
							<!--<button type="button" class="btn_sound"><img src="/ssflex_cs1/assets/img/common/ico/ico_headphone.svg"></button>
							<audio v-if="qstTstList[index].isAudio" :src="qstTstList[index].tstAudioSrc" controls="controls"></audio>-->

							<div class="audio_box" v-if="qstTstList[index].isAudio">
								<audio class="audio" :id="'qst-audio-' + qstTstList[index].qtIdx">
									<source :src="qstTstList[index].tstAudioSrc" type="audio/mpeg">
									Your browser does not support the audio element.
								</audio>
								<button type="button" class="btn_play" @click="mediaUtils.audioPlay('#qst-audio-' + qstTstList[index].qtIdx);"><img src="/ssflex_cs1/assets/img/common/ico/ico_play.svg"></button>
								<button type="button" class="btn_pause" @click="mediaUtils.audioPause('#qst-audio-' + qstTstList[index].qtIdx);"><img src="/ssflex_cs1/assets/img/common/ico/ico_pause.svg"></button>
							</div>

						</div>
					</div>
					<div class="a_wrap">
						<ul>

							<!-- 단일선택 -->
							<template v-if="qstTstList[index].tstType === 'single'">
								<li v-for="(ans, idx) in qstTstList[index].answerList">
									<input class="inp_radio" type="radio" :id="'single-' + ans.taIdx" :name="'single-' + ans.qtIdx" :value="ans.taIdx" v-model="ansTstList[index].taIdx" @click="logAnswer">
									<label class="lab_radio" :for="'single-' + ans.taIdx">
										<div class="lab_left">{{ idx + 1 }}. {{ ans.answer }}</div>
										<div class="lab_right" v-if="!$options.filters.isEmpty(ans.answerImgSrc)"><img :src="ans.answerImgSrc" height=""></div>
										<div class="lab_right" v-if="!$options.filters.isEmpty(ans.answerAudioSrc)">
											<div class="audio_box">
												<audio class="audio" :id="'ans-audio-' + ans.taIdx">
													<source :src="ans.answerAudioSrc" type="audio/mpeg">
													Your browser does not support the audio element.
												</audio>
												<button type="button" class="btn_play" @click="mediaUtils.audioPlay('#ans-audio-' + ans.taIdx);"><img src="/ssflex_cs1/assets/img/common/ico/ico_play.svg"></button>
												<button type="button" class="btn_pause" @click="mediaUtils.audioPause('#ans-audio-' + ans.taIdx);"><img src="/ssflex_cs1/assets/img/common/ico/ico_pause.svg"></button>
											</div>
										</div>
									</label>
								</li>
							</template>


							<!-- 다중선택 -->
							<template v-if="qstTstList[index].tstType === 'multi'">
								<li v-for="(ans, idx) in qstTstList[index].answerList">
									<input class="inp_radio" type="checkbox" :id="'multi-' + ans.taIdx" :name="'multi-' + ans.taIdx" :value="ans.taIdx" v-model="ansTstList[index].taIdxs" @click="logAnswer">
									<label class="lab_radio" :for="'multi-' + ans.taIdx">
										<div class="lab_left">{{ idx + 1 }}. {{ ans.answer }}</div>
										<div class="lab_right" v-if="!$options.filters.isEmpty(ans.answerImgSrc)"><img :src="ans.answerImgSrc" height=""></div>
										<div class="lab_right" v-if="!$options.filters.isEmpty(ans.answerAudioSrc)">
											<div class="audio_box">
												<audio class="audio" :id="'ans-audio-' + ans.taIdx">
													<source :src="ans.answerAudioSrc" type="audio/mpeg">
													Your browser does not support the audio element.
												</audio>
												<button type="button" class="btn_play" @click="mediaUtils.audioPlay('#ans-audio-' + ans.taIdx);"><img src="/ssflex_cs1/assets/img/common/ico/ico_play.svg"></button>
												<button type="button" class="btn_pause" @click="mediaUtils.audioPause('#ans-audio-' + ans.taIdx);"><img src="/ssflex_cs1/assets/img/common/ico/ico_pause.svg"></button>
											</div>
										</div>
									</label>
								</li>
							</template>


							<!-- 주관식 -->
							<template v-if="qstTstList[index].tstType === 'short'">
								<li>
									<input type="text" class="inp" style="width: 100%;" v-model="ansTstList[index].shortTxt" placeholder="주관식 답안을 입력해주세요.">
								</li>
							</template>


						</ul>
						<div class="test_button">

							<button type="button" class="btn btn-lg btn-dark" v-show="index > 0" @click="index--">이전</button>
							<button type="button" class="btn btn-lg btn-dark m-l-10" v-show="qstTstList.length > index + 1" @click="saveAnswer">다음</button>
							<button type="submit" class="btn btn-lg btn-dark m-l-10" v-show="qstTstList.length === index + 1" @click="saveAnswer">답안 확인</button>

						</div>
					</div>
				</div>
			</section>


			<!-- 테스트 최종답안 확인 -->
			<section class="learning_test" v-if="isFinal && !isComplete">
				<div class="test_correct">

					<template v-for="(qst, i) in qstTstList">
						<div class="q_wrap">
							<strong>{{ qst.tstTitle }}</strong>
							<p v-if="qst.isTxt">{{ qst.tstDesc }}</p>
							<div class="img_wrap" v-if="qst.isImg || qst.isAudio">
								<div class="img_question" v-if="qst.isImg"><img :src="qst.tstImgSrc"></div>
								<!--<button type="button" class="btn_sound"><img src="/ssflex_cs1/assets/img/common/ico/ico_headphone.svg"></button>-->
								<audio v-if="qst.isAudio" :src="qst.tstAudioSrc" controls="controls"></audio>
							</div>
						</div>
						<div class="a_wrap">
							<ul>

								<template v-if="qst.tstType === 'single' && ans.taIdx === ansTstList[i].taIdx" v-for="(ans, a) in qst.answerList">
									<li>
										<input class="inp_radio" type="checkbox" :id="'single-' + ans.taIdx" :name="'single-' + ans.qtIdx" checked="checked">
										<label class="lab_radio" :for="'single-' + ans.taIdx">
											<div class="lab_left">{{ a + 1 }}. {{ ans.answer }}</div>
											<div class="lab_right" v-if="!$options.filters.isEmpty(ans.answerImgSrc)"><img :src="ans.answerImgSrc" height=""></div>

											<div class="lab_right" v-if="!$options.filters.isEmpty(ans.answerAudioSrc)">
												<div class="audio_box">
													<audio class="audio" :id="'ans-audio-' + ans.taIdx">
														<source :src="ans.answerAudioSrc" type="audio/mpeg">
														Your browser does not support the audio element.
													</audio>
													<button type="button" class="btn_play" @click="mediaUtils.audioPlay('#ans-audio-' + ans.taIdx);"><img src="/ssflex_cs1/assets/img/common/ico/ico_play.svg"></button>
													<button type="button" class="btn_pause" @click="mediaUtils.audioPause('#ans-audio-' + ans.taIdx);"><img src="/ssflex_cs1/assets/img/common/ico/ico_pause.svg"></button>
												</div>
											</div>
										</label>
									</li>
								</template>

								<template v-if="qst.tstType === 'multi'" v-for="(ans, a) in qst.answerList">
									<template v-for="(taIdx, t) in ansTstList[i].taIdxs">
										<li v-if="taIdx == ans.taIdx">
											<input class="inp_radio" type="checkbox" :id="'multi-' + ans.taIdx" :name="'multi-' + ans.qtIdx" checked="checked">
											<label class="lab_radio" :for="'multi-' + ans.taIdx">
												<div class="lab_left">{{ a + 1 }}. {{ ans.answer }}</div>
												<div class="lab_right" v-if="!$options.filters.isEmpty(ans.answerImgSrc)"><img :src="ans.answerImgSrc" height=""></div>
												<div class="lab_right" v-if="!$options.filters.isEmpty(ans.answerAudioSrc)">
													<div class="audio_box">
														<audio class="audio" :id="'ans-audio-' + ans.taIdx">
															<source :src="ans.answerAudioSrc" type="audio/mpeg">
															Your browser does not support the audio element.
														</audio>
														<button type="button" class="btn_play" @click="mediaUtils.audioPlay('#ans-audio-' + ans.taIdx);"><img src="/ssflex_cs1/assets/img/common/ico/ico_play.svg"></button>
														<button type="button" class="btn_pause" @click="mediaUtils.audioPause('#ans-audio-' + ans.taIdx);"><img src="/ssflex_cs1/assets/img/common/ico/ico_pause.svg"></button>
													</div>
												</div>
											</label>
										</li>
									</template>
								</template>

								<template v-if="qst.tstType === 'short' ">
									<li>{{ ansTstList[i].shortTxt }}</li>
								</template>

							</ul>

							<div class="correct_button">
								<button type="button" class="btn btn-sm btn-dark" data-toggle="modal" data-target="#correct" @click="showEditlayer(i)">수정하기</button>
							</div>
						</div>

					</template>


					<!--{{ ansTstList[index].taIdx }}<br>
					{{ ansTstList[index].taIdxs }}-->

					<div class="btn-wrap text-center">
						<button type="submit" class="btn btn-lg btn-dark" @click="doSubmit">
							<template v-if="$parent.isNext()">다음</template>
							<template v-else>답안 제출</template>
						</button>
					</div>


					<!-- learning modal -->
					<div class="correct modal fade" id="learning-modal" tabindex="-1" aria-labelledby="correct" aria-hidden="true">
						<div class="modal-dialog modal-lg modal-dialog-centered">
							<div class="modal-content" v-for="(qst, i) in qstTstList" v-if="i === index">
								<div class="modal-header">
									<h2 class="modal-title">{{ i + 1 }}번 {{ qst.tstTitle }}</h2>
								</div>
								<div class="modal-body">
									<div class="a_wrap">

										<!-- 단일선택 -->
										<ul v-if="qst.tstType === 'single' ">
											<li v-for="(ans, idx) in qst.answerList">
												<input class="inp_radio" type="radio" :id="'singlePop-' + ans.taIdx" :value="ans.taIdx" v-model="setAnsTst.taIdx" @click="logAnswer">
												<label class="lab_radio" :for="'singlePop-' + ans.taIdx">
													<div class="lab_left">{{ idx + 1 }}. {{ ans.answer }}</div>
													<div class="lab_right" v-if="!$options.filters.isEmpty(ans.answerImgSrc)"><img :src="ans.answerImgSrc" height="" class="tst-image"></div>
													<div class="lab_right" v-if="!$options.filters.isEmpty(ans.answerAudioSrc)">
														<div class="audio_box">
															<audio class="audio" :id="'ans-audio-' + ans.taIdx">
																<source :src="ans.answerAudioSrc" type="audio/mpeg">
																Your browser does not support the audio element.
															</audio>
															<button type="button" class="btn_play" @click="mediaUtils.audioPlay('#ans-audio-' + ans.taIdx);"><img src="/ssflex_cs1/assets/img/common/ico/ico_play.svg"></button>
															<button type="button" class="btn_pause" @click="mediaUtils.audioPause('#ans-audio-' + ans.taIdx);"><img src="/ssflex_cs1/assets/img/common/ico/ico_pause.svg"></button>
														</div>
													</div>
												</label>
											</li>
										</ul>

										<!-- 다중선택 -->
										<ul v-if="qst.tstType === 'multi' ">
											<li v-for="(ans, idx) in qst.answerList">
												<input class="inp_radio" type="checkbox" :id="'multiPop-' + ans.taIdx" :value="ans.taIdx" v-model="setAnsTst.taIdxs" @click="logAnswer">
												<label class="lab_radio" :for="'multiPop-' + ans.taIdx">
													<div class="lab_left">{{ idx + 1 }}. {{ ans.answer }}</div>
													<div class="lab_right" v-if="!$options.filters.isEmpty(ans.answerImgSrc)"><img :src="ans.answerImgSrc" height="" class="tst-image"></div>
													<div class="lab_right" v-if="!$options.filters.isEmpty(ans.answerAudioSrc)">
														<div class="audio_box">
															<audio class="audio" :id="'ans-audio-' + ans.taIdx">
																<source :src="ans.answerAudioSrc" type="audio/mpeg">
																Your browser does not support the audio element.
															</audio>
															<button type="button" class="btn_play" @click="mediaUtils.audioPlay('#ans-audio-' + ans.taIdx);"><img src="/ssflex_cs1/assets/img/common/ico/ico_play.svg"></button>
															<button type="button" class="btn_pause" @click="mediaUtils.audioPause('#ans-audio-' + ans.taIdx);"><img src="/ssflex_cs1/assets/img/common/ico/ico_pause.svg"></button>
														</div>
													</div>
												</label>
											</li>
										</ul>

										<!-- 주관식 -->
										<ul v-if="qst.tstType === 'short' ">
											<li>
												<input type="text" class="inp" style="width: 100%;" v-model="setAnsTst.shortTxt" placeholder="주관식 답안을 입력해주세요.">
											</li>
										</ul>
									</div>
								</div>
								<div class="modal-footer">
									<button type="button" class="btn btn-dark btn-lg" @click="editAnsTst">확인</button>
								</div>
								<button type="button" class="btn_close" data-dismiss="modal" aria-label="Close">
									<img src="/ssflex_cs1/assets/img/common/ico/ico_close.svg" alt="닫기">
								</button>
							</div>
						</div>
					</div>
					<!-- //learning modal -->


				</div>
			</section>
			<!-- e : 답안 확인 최종 페이지 -->


			<!-- 테스트 결과 -->
			<section class="learning_test" v-if="isFinal && isComplete">
				<div class="test_done">
					<h3>테스트 결과</h3>
					<table class="tbl">
						<tr>
							<th>문항 수</th>
							<td>{{ qstTstList.length }} 문항</td>
						</tr>
						<tr>
							<th>정답 수</th>
							<td>{{ correctCount }} 문항</td>
						</tr>
					</table>

					<div class="test_button" v-if="$options.filters.isEmpty( $route.query.isReplay )">
						<button type="button" class="btn btn-lg btn-point" @click="doComplete">테스트 완료</button>
					</div>
					<div class="test_button" v-else>
						<button type="button" class="btn btn-lg btn-point" @click="stopProceed">종료</button>
					</div>

				</div>
			</section>


		</section>

	</div>

</template>

<script>
import AnsTstStart from "@/cs1/components/educations/answer/ansTstStart";

export default {
	name: "ans-tst",
	components: {AnsTstStart},
	// props: ["eduMain", "eduContent", "qstTstList"],
	props: [
		"eduMain",
		"eduContent",
		"eduAnswer",
	],
	data: function () {

		return {

			userId: this.getLoginId(),
			qstTstList: this.eduContent.qstTstList,

			index: 0,
			number: 1,
			setAnsTst: {},
			ansTstList: this.eduAnswer.ansTstList,

			isStart: false,
			isFinal: false,
			isComplete: false,
			correctCount: 0,        // 정답수
			showIndex: 0,
		}
	},
	created: function () {

	},
	mounted: function () {

		//console.log("ans-tst");
		//console.log(this.eduMain)
		//console.log(this.eduContent)
		//console.log(this.eduAnswer)

		// 선택답안 순서 섞기
		this.qstTstList.forEach(qstTst => {
			if (qstTst.isShuffle && !qstTst.isDrag) {
				this.arrayUtils.shuffle(qstTst.answerList)
			}
		})

		/**
		 * 초기 + 이어하기 답변 목록 설정
		 */
		if (this.ansTstList != null && this.ansTstList.length > 0) {
			this.prevAnswers();
		}


	},
	methods: {


		/**
		 * 기존 답안 현재 답안 형태로 설정
		 */
		prevAnswers: function () {

			var self = this;
			//console.log("prevAnswers")
			//console.log(this.ansTstList)

			var i = 0;
			var stop = 0;
			this.ansTstList.forEach(vo => {

				vo.taIdx = 0
				vo.taIdxs = []

				if (!this.stringUtils.isEmpty(vo.selTaIdxs) || !this.stringUtils.isEmpty(vo.shortTxt)) {

					if (self.qstTstList[i].tstType === "single") {
						vo.taIdx = parseInt(vo.selTaIdxs);
					} else if (self.qstTstList[i].tstType === "multi") {
						vo.taIdxs = vo.selTaIdxs.split(",");
					} else if (self.qstTstList[i].tstType === "short") {
						vo.shortTxt = vo.shortTxt;
					}
					i++;

					self.isStart = true;
					// self.index++;
					if (self.index + 1 >= self.qstTstList.length) {
						self.isFinal = true;
					} else {

						console.log(self.ansTstList[self.index].selTaIdxs)

						// 중간에 답이 없을 경우 스템 증가 중단
						// ex : 관리자에서 수동으로 완료처리 했을 경우
						// 객관식과 주관식 둘중 하나라도 답이 있으면 다음 문제
						if (!self.stringUtils.isEmpty(self.ansTstList[self.index].selTaIdxs) || !self.stringUtils.isEmpty(self.ansTstList[self.index].shortTxt)) {
							self.index++;
						}
					}
				} else {
					//self.index--;

					// 중간에 끊긴 답안이 있을 경우 해당 번호 저장
					/*if ( stop <= 0 ) {
						stop = i;
					}*/
				}
			})


			// 답안 끊긴 번호 있을 경우 : 해당번호로 이동
			// 없을 경우 : 인덱스로 이동
			/*if ( stop > 0 ) {
				self.index = stop;
			}*/

		},


		/**
		 * 테스트 시작버튼
		 */
		tstStart: function () {

			//console.log("tstStart")
			this.isStart = true;
			this.index = 0;
		},

		/**
		 * 현재 답변 저장
		 */
		saveAnswer: function () {

			if (this.qstTstList[this.index].tstType === "single" || this.qstTstList[this.index].tstType === "multi") {

				// 답안 체크 여부 확인
				if (this.ansTstList[this.index].taIdx === 0 && this.ansTstList[this.index].taIdxs.length <= 0) {
					this.swalUtils.gritter("선택된 답이 없습니다.", "답안을 선택해주세요.", "warning")
					//alert( "답안을 선택해주세요." );
					return;
				}

			} else {

				if (this.ansTstList[this.index].shortTxt.trim() === "") {
					this.swalUtils.gritter("선택된 답이 없습니다.", "주관식 답안을 입력해주세요.", "warning")
					//alert( "주관식 답안을 입력해주세요." );
					return;
				}

			}


			var self = this;

			// 현재 선택답 설정
			if (self.qstTstList[self.index].tstType === "single") {
				self.ansTstList[self.index].selTaIdxs = self.ansTstList[self.index].taIdx;
			} else if (self.qstTstList[self.index].tstType === "multi") {
				self.ansTstList[self.index].selTaIdxs = self.ansTstList[self.index].taIdxs.join(",");
			}

			let params = {
				seq: self.ansTstList[self.index].seq,
				qtIdx: self.ansTstList[self.index].qtIdx,
				eaIdx: self.ansTstList[self.index].eaIdx,
				selTaIdxs: self.ansTstList[self.index].selTaIdxs,
			};

			/**
			 * if 문제가 오답체크 설정되어 있고 처음 풀때만 저장
			 * else 정답체크 후 새로고침 or 오답처리 + 재풀이
			 */
			if (!self.qstTstList[self.index].directCorrect) {

				this.axiosCaller.patch(this, this.APIs.EDU_ANSWER + "/tstAns", params, function (res) {

					self.$eventBus.$emit("doneProgress")

					const result = res.data;
					if (result.status === "ok") {

						// 현재 문제 인덱스 + >= 문제항목개수 보다 같거나 많을 경우 최종확인
						if (self.index + 1 >= self.qstTstList.length) {
							self.isFinal = true;
						} else {

							// 다음문제를 처음 오픈시 새로고침 형태로 표출
							if (self.ansTstList[self.index + 1].selTaIdxs != null) {
								self.index++;
							} else {
								location.reload()
							}
						}
					}
				})

			} else {

				this.axiosCaller.get(this, this.APIs.EDU_ANSWER + "/tstAns/isCorrect", params, function (res) {
					const result = res.data;
					if (result.status === "ok") {
						if (result.isCorrect) {

							self.qstTstList[self.index].directCorrect = false
							self.saveAnswer();
						} else {
							self.swalUtils.gritter("오답", "문제를 다시 풀어주세요.", "error")
						}
					}
				})

			}

		},


		/**
		 * 답안 제출 + 일괄 저장
		 */
		doSubmit: function () {

			this.$eventBus.$emit("startProgress")


			var saveAnswers = [];
			// TODO : 답안 실제 저장처리
			var i = 0;
			this.ansTstList.forEach(answer => {

				// 문항 변경시 체크를 위한 선택문항 데이터 재설정
				answer.qtIdx = this.qstTstList[i].qtIdx

				// 현재 선택답 설정
				if (this.qstTstList[i].tstType === "single") {
					answer.selTaIdxs = answer.taIdx;
				} else if (this.qstTstList[i].tstType === "multi") {
					answer.selTaIdxs = answer.taIdxs.join(",");
				}

				saveAnswers.push(answer)
				i++;
			})


			var self = this
			this.axiosCaller.put(this, this.APIs.EDU_ANSWER + "/tstAns", {
				'ecIdx': this.eduContent.ecIdx,
				'userId': this.getLoginId(),
				'answers': this.ansTstList,
			}, function (res) {
				self.$eventBus.$emit("doneProgress")

				const result = res.data;
				console.log(result)
				self.isComplete = true;
				self.correctCount = result.correctCount;

				// 다음 교육으로 이동
				/*if ( result.status == "ok" ) {
					self.$emit("goNext")
				}*/

			})


		},


		/**
		 * 현재까지의 답변 확인용
		 */
		logAnswer: function () {
			//console.log(this.index)
			//console.log(this.ansTstList)
		},


		/**
		 * 답안 수정 오픈
		 */
		showEditlayer: function (_index) {

			this.setAnsTst = new this.AnsTstVO();
			this.setAnsTst.taIdx = this.ansTstList[_index].taIdx
			this.setAnsTst.taIdxs = this.ansTstList[_index].taIdxs
			this.setAnsTst.shortTxt = this.ansTstList[_index].shortTxt

			//console.log(this.setAnsTst)
			this.index = _index
			this.showIndex = _index;

			$('#learning-modal').modal();
			//this.fadeIn('#__tstPopup');

		},


		editAnsTst: function () {

			this.ansTstList[this.index].taIdx = this.setAnsTst.taIdx;
			this.ansTstList[this.index].taIdxs = this.setAnsTst.taIdxs;
			this.ansTstList[this.index].shortTxt = this.setAnsTst.shortTxt;

			const tmpList = this.ansTstList;
			this.ansTstList = []
			this.ansTstList = tmpList

			$('#learning-modal').modal('hide');
			//this.fadeOut('#__tstPopup');
		},


		closeLayer: function () {

			this.setAnsTst = new this.AnsTstVO();
			//console.log(this.setAnsTst)

			this.index = this.ansTstList.length - 1
			//console.log(this.index)
			//console.log(this.ansTstList)
			$('#learning-modal').modal('hide');
			//this.fadeOut('#__tstPopup');
		},


		// doSubmit 에서 이미 테스트 완료처리 > 페이지 이동만
		doComplete: function () {

			var self = this;
			self.$emit("goNext");
		},


		stopProceed() {
			this.appClose({
				reload: true,
			})
		},
	},
	watch: {

		'index': function (newVal) {
			//console.log(this.ansTstList)
		},

		'showIndex': function (newVal) {
			//console.log(this.ansTstList[newVal])
		}

		/*'index': function (newVal, oldVal) {

			// 다음 버튼
			if ( oldVal < newVal && (newVal - oldVal) == 1 ) {

				// 현재 문제가 객관식일 경우
				if ( this.qstTstList[oldVal].tstType == "single" || this.qstTstList[oldVal].tstType == "multi" ) {

					// 답안 체크 여부 확인
					if ( this.answerList[oldVal].taIdx == 0 && this.answerList[oldVal].taIdxs.length <= 0 ) {
						alert( "답안을 선택해주세요." );
						this.index--;
						return;
					}

				} else {

					if ( this.answerList[oldVal].shortTxt.trim() == "" ) {
						alert( "주관식 답안을 입력해주세요." );
						this.index--;
						return;
					}

				}

				// 현재 답안 실제 저장처리
				this.saveAnswer(oldVal);

				// 다음문제가 있을 경우
				if ( newVal < this.qstTstList.length ) {

					if ( typeof this.answerList[newVal] === "undefined") {
						this.answerList.push( this.addAnswer() );
					}
				} else {

					// 답안 전체 확인 페이지 표출
					this.index--;
					this.isFinal = true;

				}

			}

		}*/

	}
}
</script>

<style>
</style>